var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vwc-textfield", {
    ref: "textfield",
    staticClass: "text-field",
    attrs: {
      required: _vm.required,
      autovalidate: _vm.autoValidate,
      validationmessage: _vm.validationMessage,
      dense: "",
      label: _vm.label,
      placeholder: _vm.placeholder,
      value: _vm.value,
      pattern: _vm.pattern,
      helper: _vm.helper,
      disabled: _vm.disabled,
      charcounter: _vm.charCounter,
      maxlength: _vm.maxLength,
      outlined: "",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("textChanged", $event.target.value)
      },
      focusout: function ($event) {
        return _vm.$emit("textFieldFocusout")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }